import { render } from "./UploadMenuItem.vue?vue&type=template&id=7686cc1e&ts=true"
import script from "./UploadMenuItem.vue?vue&type=script&lang=ts"
export * from "./UploadMenuItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__